export default __webpack_public_path__ + "da76ef816d7cfbf06e7b98cd34ec4825.woff2";